module.exports = __webpack_public_path__ + "img/bianca.0d6cb247.png";